import { useQuery } from '@tanstack/react-query'
import * as endPoints from '@/endpoints'
import useAuth from '@/hooks/useAuth'
import axios from '@/lib/axios'

const useMeters = () => {
    const { activeOrg } = useAuth()
    const activeOrgId = activeOrg?.id

    return useQuery({
        queryKey: ['powerMeters', activeOrgId],
        queryFn: () =>
            axios.get(endPoints.POWER_METERS).then((response) => response.data),
        enabled: Boolean(activeOrgId),
        staleTime: 1000 * 60 * 2, // 5 minutes
        placeholderData: () => []
    })
}

export default useMeters
